import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Button, Carousel } from "react-bootstrap";
import "./custom.scss";
import situations from "./content/situations.json"; // Assuming this array contains strings
import benefitsData from "./content/benefits.json"; // Assuming this array contains strings
import Connect from "./connect";
import SEOHelmet from "./SEOHelmet";

export default function Home() {
  const [displayedText, setDisplayedText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [typingIndex, setTypingIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(true);
  const [responseText, setResponseText] = useState(""); // For displaying the response
  const [responseTypingIndex, setResponseTypingIndex] = useState(0); // For word-by-word typing in the response
  const [isTypingResponse, setIsTypingResponse] = useState(false); // To control when the response starts typing
  const carouselRef = useRef(null);

  // map the Need attribute in the roleOrServices to an array of strings (prompts)
  const promptArray = situations.map((service) => service.need);
  // map the Description attribute in the roleOrServices to an array of strings (responses)
  const responseArray = situations.map((service) => service.description);

  // Handle the prompt typing effect
  useEffect(() => {
    if (isTyping) {
      if (typingIndex < promptArray[currentIndex].length) {
        const timeout = setTimeout(() => {
          setDisplayedText(
            (prev) => prev + promptArray[currentIndex][typingIndex]
          );
          setTypingIndex((prev) => prev + 1);
        }, 150); // Adjust typing speed here
        return () => clearTimeout(timeout);
      } else {
        // Once the prompt is fully typed, clear it and start typing the response
        setTimeout(() => {
          setIsTyping(false);
          setIsTypingResponse(true); // Start typing the response
        }, 1000); // Optional delay before clearing prompt and starting response
      }
    }
  }, [typingIndex, isTyping, promptArray, currentIndex]);

  // Handle the response typing effect word by word
  useEffect(() => {
    if (isTypingResponse) {
      const responseWords = responseArray[currentIndex].split(" "); // Split response into words
      if (responseTypingIndex < responseWords.length) {
        const timeout = setTimeout(() => {
          setResponseText(
            (prev) => prev + " " + responseWords[responseTypingIndex]
          );
          setResponseTypingIndex((prev) => prev + 1);
        }, 250); // Adjust speed for word-by-word typing
        return () => clearTimeout(timeout);
      } else {
        // Once the response is fully typed, reset everything for the next prompt-response cycle
        setTimeout(() => {
          setResponseText(""); // Clear the response
          setDisplayedText(""); // Clear the prompt
          setTypingIndex(0);
          setResponseTypingIndex(0);
          setCurrentIndex((prev) => (prev + 1) % promptArray.length); // Move to the next prompt
          setIsTyping(true); // Start typing the next prompt
          setIsTypingResponse(false); // Stop response typing
        }, 4000); // Delay before clearing response and starting next prompt
      }
    }
  }, [
    isTypingResponse,
    responseTypingIndex,
    responseArray,
    currentIndex,
    promptArray.length,
  ]);

  return (
    <>
      <SEOHelmet 
        title="Rick Molenaar - IT Management Consulting & Interim Engineering Leadership"
        description="Interim CTO, VP Engineering & Strategic IT Consultant. Expert in tech organization design, engineering leadership transitions, and complex project delivery across fintech, energy & travel sectors."
        canonicalUrl="https://rickmolenaar.me/"
      />
      <Container className="bg-theme-secondary full-height" fluid>
        <Row className="w-100">
          <Col
            xs={12}
            className="d-flex flex-column justify-content-center align-items-center text-center"
          >
            <img
              src="./images/rick_1024.jpg"
              alt="Rick Molenaar"
              className="circular-image mb-3"
            />
            <h1 className="text-theme-accent1">Rick Molenaar</h1>
            <p className="text-theme-accent1">
              Interim Engineering Leadership • Where Org Meets Technical Reality • Fix, Improve, Hand Back
            </p>
          </Col>
        </Row>
      </Container>
      <Container
        className="bg-dark full-height justify-content-center align-items-center "
        fluid
      >
        <Row>
          <Col align="center">
            <div className="chat-box-container">
              <div id="chatInputBox" className="text-white bg-dark">
                <span id="displayedText" data-testid="displayedText">
                  {displayedText}
                </span>
              </div>
              &nbsp; &nbsp;
              {responseText && (
                <div className="bg-accent1 text-white H-100 response-text">
                  {responseText}
                </div>
              )}
              <div className="mt-3 mb-3">
                <Button variant="primary" href="./hireme">
                  Find out More
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <Container
        className="bg-theme-primary full-height d-flex justify-content-center"
        fluid
      >
        <Row>
          <Col>
            <Container>
              <Row>
                <Col className="text-theme-accent1" align="center">
                  <div className="text-center mt-3 mb-3">
                    <img
                      src="./logo/rick_bridge_with_water 180.svg"
                      alt="Orchestrating Transitions"
                      className="img-fluid"
                    />
                  </div>
                  &nbsp;
                  <h1 className="text-theme-accent1">What I Offer</h1>
                  &nbsp;
                </Col>
              </Row>
            </Container>
            <Container>
              <Row>
                <Col>
                  <Carousel
                    ref={carouselRef}
                    indicators={true}
                    interval={5000}
                    keyboard={true}
                    pauze="hover"
                    touch={true}
                  >
                    {benefitsData.map((benefit, index) => {
                      if (benefit) {
                        return (
                          <Carousel.Item key={`SuccessStory_${index}`}>
                            <div className="text-center carousel-slide-content">
                              <h3 className="text-theme-accent2">
                                {benefit.title}
                              </h3>
                              <p className="text-theme-accent3">
                                {benefit.description}
                              </p>
                            </div>
                          </Carousel.Item>
                        );
                      }
                      return null;
                    })}
                  </Carousel>
                </Col>
              </Row>
              <Row>
                <Col align="center">
                  <div className="mt-3 mb-3">
                    <Button variant="primary" href="./hireme">
                      Interested to find out how I can help you? Let's connect!
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
      <Connect />
    </>
  );
}
